import { headerHandler, dynamicLogo } from './header/index.js';
import { footerToggleHandler } from './footer/index.js';
import { imgPopupSrcHandler } from './article/index.js';
import { showPromo } from "./promo/index.js"; 
import { makeActiveContent, handleCopyLinkBthClick } from "./sidebar/index.js";
import { hpSubscription } from "./hp_subscription/index.js"; 
import { copyContent } from "./category-banner/index.js";
import { 
	showLoader,
    backToTopHandler,
    themeSwitchHandler,
}  from "./utils/index.js";

// document.addEventListener("DOMContentLoaded", function() {

	//-----header----------
	headerHandler();
	dynamicLogo();

	//-----footer----------
	footerToggleHandler();

	//-----article---------
	imgPopupSrcHandler();

    //-----sidebar---------
    makeActiveContent();
    handleCopyLinkBthClick(); 
	//-------utils---------
	showPromo();
	backToTopHandler();
    themeSwitchHandler();
	hpSubscription();

    //------category-banner-for-sidebar-----
    copyContent('.category-banner__wrap', '#category-banner__promocode', '.category-banner__promocode-copy');
	
	//------telegram-comment-box-widget-----
	if($('#telegram-comment-widget').length !== 0){
        let iframeObserve = () => {
            let tgWidgetIframe = $('#telegram-comment-widget iframe');
            if(tgWidgetIframe.length === 0){
                showLoader('.telegram-comment-widget__wrap .loader');
            } else {
                showLoader('.telegram-comment-widget__wrap .loader', false);
            }
        }
        const observer = new MutationObserver(iframeObserve);
        observer.observe(document.getElementById('telegram-comment-widget'), {childList: true});
    }
// });